<template>
  <div class="reimbursementPage">
    <div class="wrap">
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.applicantIdName"
          v-if="mode != 'add'"
          class="ggInput"
          input-align="right"
          readonly
          label="申请人："
        />
        <van-field
          v-model="userinfo.realName"
          readonly
          v-else
          class="ggInput"
          input-align="right"
          label="申请人："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="createTime"
          label="申请日期："
          readonly
          class="ggInput"
          input-align="right"
        />
      </van-cell-group>
      <!-- 所属项目 -->
      <van-cell-group class="itemSite baseNone beizhu">
        <van-field
          v-model="projectName"
          :required="editType"
          type="textarea"
          label="所属项目："
          placeholder="请选择"
          @click="showItemPickerFun"
          readonly
          input-align="right"
          rows="1"
          :is-link="editType"
          autosize
        />
      </van-cell-group>
      <div v-if="projectName">
        <van-cell-group class="itemSite baseNone beizhu">
          <van-field
            :value="
              incomeAndExpenses.contractAmount != null
                ? incomeAndExpenses.contractAmount
                : 0
            "
            label="合同金额："
            readonly
            class="ggInput"
            input-align="right"
          />
        </van-cell-group>
        <van-cell-group class="itemSite baseNone beizhu">
          <van-field
            v-model="incomeAndExpenses.expenses"
            label="项目支出："
            @click="
              parseFloat(incomeAndExpenses.expenses) > 0
                ? getMoneyDetail('expend')
                : ''
            "
            :is-link="parseFloat(incomeAndExpenses.expenses) > 0"
            readonly
            class="ggInput"
          />
        </van-cell-group>

        <div
          :class="[
            'projectIncome',
            incomeAndExpenses.contractAmount != null &&
            parseFloat(incomeAndExpenses.contractAmount) > 0 &&
            incomeAndExpenses.income != null &&
            parseFloat(incomeAndExpenses.income) > 0
              ? 'changeW'
              : '',
          ]"
        >
          <van-cell-group class="itemSite baseNone beizhu">
            <van-field
              v-model="incomeAndExpenses.income"
              label="项目到账："
              @click="
                parseFloat(incomeAndExpenses.income) > 0
                  ? getMoneyDetail('income')
                  : ''
              "
              readonly
              :is-link="parseFloat(incomeAndExpenses.income) > 0"
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="marketPercent"
              label="营销成本限额比例（%）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="marketingCost"
              label="营销成本限额（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="marketingCostTotal"
              label="累计营销已支出成本（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="remainMarketingCost"
              label="剩余营销可支出成本（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="technologyPercent"
              label="技术成本限额比例（%）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="technicalCost"
              label="技术成本限额（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="technicalCostTotal"
              label="累计技术已支出成本（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="remainTechnicalCost"
              label="剩余技术可支出成本元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="bidCostTotal"
              label="累计投标成本（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="receptionPercent"
              label="招待成本限额比例（%）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="receptionCost"
              label="招待成本限额（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="receptionCostTotal"
              label="累计已支出招待费（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="remainReceptionCost"
              label="剩余可支出招待费（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
        </div>
      </div>
      <van-cell-group class="baseNone baseSalary beizhu moreText">
        <van-field
          v-model="propertyData.firstTypeName"
          label="资金用途类别："
          :required="editType"
          readonly
          type="textarea"
          rows="1"
          autosize
          class="ggInput"
          input-align="right"
          @click="showBxTypePickerFun(1)"
          :is-link="editType"
          :placeholder="editType ? '请选择' : ''"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary beizhu">
        <van-field
          v-model="propertyData.secondTypeName"
          label="二级类别："
          :required="editType"
          readonly
          type="textarea"
          rows="1"
          autosize
          class="ggInput"
          input-align="right"
          @click="showBxTypePickerFun(2)"
          :is-link="editType"
          :placeholder="editType ? '请选择' : ''"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary beizhu">
        <van-field
          v-model="propertyData.thirdTypeName"
          label="三级类别："
          :required="editType"
          readonly
          type="textarea"
          rows="1"
          autosize
          class="ggInput"
          input-align="right"
          @click="showBxTypePickerFun(3)"
          :is-link="editType"
          :placeholder="editType ? '请选择' : ''"
        />
      </van-cell-group>

      <van-cell-group class="itemSite baseNone beizhu">
        <van-field
          v-model="propertyData.companyTypeName"
          :required="editType"
          label="付款类型："
          placeholder="请选择"
          :is-link="editType"
          @click="showFuKuanType"
          readonly
          input-align="right"
        />
      </van-cell-group>
      <van-cell-group
        class="baseNone baseSalary"
        v-if="propertyData.companyType == 'inner'"
      >
        <van-field
          :required="editType"
          v-model="selectPeopleNames"
          placeholder="请选择"
          @click="showSelectPeople"
          readonly
          :is-link="editType"
          class="ggInput"
          label="收款人："
          type="textarea"
          rows="1"
          autosize
        />
      </van-cell-group>
      <div
        class="claimDetailMain"
        v-if="propertyData.companyType == 'inner' && innerShow"
      >
        <p class="tit">付款明细</p>
        <van-cell-group class="claimDetailBox">
          <div class="claimDetailLists">
            <div
              class="claimItem"
              v-for="(item, index) in propertyData.accountInfoParams"
              :key="index"
            >
              <van-cell-group class="baseNone baseSalary">
                <van-field
                  :required="editType"
                  type="number"
                  v-model="item.receiveAmount"
                  placeholder="请输入金额"
                  :readonly="!editType"
                  @input="changeAmount"
                  class="ggInput"
                  :label="item.staffName + '：'"
                />
              </van-cell-group>
              <div
                class="delectClaim"
                v-if="propertyData.accountInfoParams.length > 0 && editType"
              >
                <van-icon name="cross" @click="delectInnerClaim(index)" />
              </div>
            </div>
          </div>
        </van-cell-group>
      </div>
      <div class="claimDetailMain" v-if="propertyData.companyType == 'outer'">
        <p class="tit">付款明细</p>
        <van-cell-group class="claimDetailBox">
          <div class="claimDetailLists">
            <div
              class="claimItem"
              v-for="(item, index) in propertyData.accountInfoParams"
              :key="index"
            >
              <van-cell-group class="baseNone baseSalary">
                <van-field
                  :required="editType"
                  type="number"
                  v-model="item.receiveAmount"
                  placeholder="请输入...  "
                  :readonly="!editType"
                  @input="changeAmount"
                  class="ggInput"
                  label="金额："
                />
              </van-cell-group>

              <van-cell-group
                class="baseNone baseSalary beizhu"
                v-if="item.collectingCompany != null"
              >
                <van-field
                  rows="1"
                  autosize
                  type="textarea"
                  :required="editType"
                  v-model="item.collectingCompany"
                  placeholder="请输入...  "
                  :readonly="!editType"
                  class="ggInput"
                  label="收款单位："
                />
              </van-cell-group>
              <van-cell-group
                class="baseNone baseSalary"
                v-if="item.paymentTypeName != null"
              >
                <van-field
                  :required="editType"
                  v-model="item.paymentTypeName"
                  placeholder="请选择"
                  @click="showPaymentType(index)"
                  readonly
                  :is-link="editType"
                  class="ggInput"
                  label="付款方式："
                />
              </van-cell-group>

              <van-cell-group
                class="baseNone baseSalary"
                v-if="item.paymentType == 'zz' || item.paymentType == 'hp'"
              >
                <van-field
                  :required="editType"
                  v-model="item.depositBank"
                  placeholder="请输入...  "
                  :readonly="!editType"
                  class="ggInput"
                  label="开户银行："
                />
              </van-cell-group>
              <van-cell-group
                class="baseNone baseSalary"
                v-if="item.paymentType == 'zz' || item.paymentType == 'hp'"
              >
                <van-field
                  :required="editType"
                  v-model="item.bankAccount"
                  placeholder="请输入...  "
                  :readonly="!editType"
                  class="ggInput"
                  label="银行账户："
                />
              </van-cell-group>
            </div>

            <div
              class="delectClaim"
              v-if="propertyData.accountInfoParams.length > 1 && editType"
            >
              <van-icon name="cross" @click="delectClaim(index)" />
            </div>
          </div>
          <div class="addBtn" v-if="editType">
            <van-button
              icon="plus"
              type="primary"
              class="addClaim"
              size="small"
              @click="addClaim"
              >添加明细</van-button
            >
          </div>
        </van-cell-group>
      </div>
      <van-cell-group class="baseNone baseSalary dwBox">
        <van-field
          v-model="propertyData.amount"
          clearable
          :required="editType"
          class="ggInput"
          input-align="right"
          readonly
          type="number"
          label="申请金额（元）："
          placeholder="0"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary beizhu">
        <van-field
          v-model="propertyData.reason"
          clearable
          rows="1"
          class="ggInput"
          input-align="right"
          :readonly="!editType"
          autosize
          type="textarea"
          :required="editType"
          label="申请原因："
          placeholder="请输入...  "
        />
      </van-cell-group>
      <van-cell-group
        class="baseNone beizhu"
        v-if="propertyData.remarks != null"
      >
        <van-field
          v-model="propertyData.remarks"
          rows="1"
          autosize
          label="备注"
          type="textarea"
          :placeholder="editType ? '请输入...  ' : ''"
          :readonly="!editType"
        />
      </van-cell-group>
      <!-- 附件 -->
      <!-- 微信的附件 避免和原生交互 -->
      <wx-file-view
        v-if="is_weixn"
        :filesData="propertyData"
        :editType="editType"
        class="fileview"
      ></wx-file-view>
      <!-- 原生附件 -->
      <file-view
        v-else
        :filesData="propertyData"
        :editType="editType"
        @changeFile="changebaseAnnexes"
        class="fileview"
      ></file-view>
      <!-- 审批流程 -->
      <div
        class="approveList"
        v-if="this.mode != 'add' && propertyData.verifyStatus != 'hold'"
      >
        <audit-list :applicantData="propertyData"></audit-list>
      </div>

      <!-- 流程图 -->
      <div
        class="flowList"
        v-if="this.mode != 'add' && propertyData.verifyStatus != 'hold'"
      >
        <flow-staff :applicantData="propertyData"></flow-staff>
        <flow-list :workflowCode="propertyData.workflowCode"></flow-list>
      </div>
      <!-- 审批 -->
      <van-popup
        v-model="verifyPageType"
        closeable
        round
        close-icon="close"
        position="bottom"
        class="verifyPage"
      >
        <verify-main
          :applicantData="propertyData"
          @changeVerifyType="setVerifyType"
        ></verify-main>
      </van-popup>
    </div>
    <!-- 保存按钮 -->
    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode == 'add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput"
        class="btn"
        >提交</van-button
      >
    </div>
    <!-- 编辑状态下 -->
    <template v-else-if="editType && mode != 'verify'">
      <div
        class="btnBox editBtnbox clearfix"
        v-if="propertyData.verifyStatus == 'hold'"
      >
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="delApply"
              class="btn"
              >删除</van-button
            >
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="checkInput"
              class="btn"
              >保存</van-button
            >
          </van-col>
        </van-row>
      </div>
      <div
        class="btnBox denyBtn clearfix"
        v-if="propertyData.verifyStatus == 'deny'"
      >
        <van-button
          type="info"
          :loading="btnLoading"
          :loading-text="loadingText"
          @click="checkInput"
          class="btn"
          >再次提交</van-button
        >
      </div>
    </template>
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        propertyData.verifyStatus == 'pending' &&
        mode != 'verify' &&
        sendType != '1'
      "
    >
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="delApply"
        class="btn"
        >撤回修改</van-button
      >
    </div>
    <!-- 审批按钮 -->
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        (mode == 'verify' &&
          propertyData.verifyStatus == 'pending' &&
          verifyType == '1') ||
        (mode == 'verify' &&
          propertyData.verifyStatus == 'doing' &&
          verifyType == '1')
      "
    >
      <van-button type="info" @click="verifyPage">{{
        verifyPageText
      }}</van-button>
    </div>
    <!-- 弹出框 -->
    <!-- 项目管理 -->
    <van-popup v-model="showItemPicker" position="bottom" class="roleBox">
      <project-view @setItems="setProject"></project-view>
    </van-popup>
    <!-- 资金用途 -->
    <van-popup v-model="showTypePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="typeColumns"
        value-key="dictName"
        @cancel="showTypePicker = false"
        @confirm="saveType"
      />
    </van-popup>
    <!-- 付款类型 -->
    <van-popup v-model="showFuKuanTypePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="FuKuanTypeList"
        value-key="dictName"
        @cancel="showFuKuanTypePicker = false"
        @confirm="saveFuKuanType"
      />
    </van-popup>

    <!-- 付款方式 -->
    <van-popup v-model="showPaymentTypePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="showPaymentTypeList"
        value-key="dictName"
        @cancel="showPaymentTypePicker = false"
        @confirm="savePaymentLevel"
      />
    </van-popup>

    <!--  收款人员管理 -->
    <van-popup v-model="showRetinuePicker" position="bottom" class="roleBox">
      <retinue-view
        :retinueUids="selectPeopleIds"
        @setReview="setRetinue"
      ></retinue-view>
    </van-popup>
    <!-- 报销类型选数组-->
    <van-popup v-model="showBxTypePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="bxTypeList"
        value-key="dictName"
        @cancel="showBxTypePicker = false"
        @confirm="saveBxType"
      />
    </van-popup>
    <!-- 项目支出或收入明细 -->
    <van-popup
      v-model="showProjectMoneyPicker"
      round
      closeable
      close-icon="close"
      position="bottom"
      class="moneyPicker"
    >
      <ul v-if="moneydetailList.length != '0'">
        <li v-for="item in moneydetailList" :key="item.id">
          <div class="incomeInfo">
            <p>
              {{ pickerType == "income" ? "到账类型" : "支出类型" }}：{{
                item.typeName
              }}
            </p>
            <p>
              {{ pickerType == "income" ? "到账时间" : "支出时间" }}：{{
                item.createTime
              }}
            </p>
            <p>
              {{ pickerType == "income" ? "到账金额" : "支出金额" }}：{{
                item.amount
              }}元
            </p>
            <p>备注：{{ item.remarks }}</p>
          </div>
        </li>
      </ul>

      <div class="nonePage" v-if="moneydetailList.length == '0' && refreshing">
        <img :src="baseUrl + 'empty.png'" alt />
        <p>暂无数据</p>
      </div>
    </van-popup>
    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";

const retinueView = () =>
  import("@/views/financeModule/capitalManage/components/selectPeople");
const projectView = () => import("@/components/businessTripMould/projectView");
const refreshPage = () => import("@/components/common/refreshPage");
const fileView = () => import("@/components/common/fileView");
const wxFileView = () => import("@/components/common/wxFileView");
const flowList = () => import("@/components/common/flowList");
const auditList = () => import("@/components/common/auditList");
const flowStaff = () => import("@/components/common/flowStaff");
const verifyMain = () => import("@/components/common/verifyMain");
import { dateFormat, getDictList, isEdit } from "@/utils/common";
import {
  getDeviceType,
  closePage,
  is_wei,
} from "@/common/getDeviceType/getDeviceType";
export default {
  name: "capitalManage",
  components: {
    refreshPage,
    fileView,
    wxFileView,
    auditList,
    flowList,
    verifyMain,
    projectView,
    flowStaff,
    retinueView,
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      mode: "add",
      editType: false, //能否编辑
      showTypePicker: false,
      showItemPicker: false, //所属项目弹框
      propertyData: {
        amount: "", //申请金额
        projectCode: "",
        projectId: "", //所属项目code
        type: "", //资金用途
        companyTypeName: "", //付款类型Name
        companyType: "", //付款类型
        reason: "", //申请原因
        remarks: "", //备注
        verifyStatus: "hold",
        fundingType: "1",
        firstType: "", //报销类型；一级码表
        firstTypeName: "", //一级码表name
        secondType: "", //报销类型；二级码表
        secondTypeName: "", //二级码表name
        thirdType: "", //报销类型；三级码表
        thirdTypeName: "", //三级码表name
        accountInfoParams: [
          //收款单位信息保存
          {
            bankAccount: "", //银行账户
            collectingCompany: "", //收款单位
            depositBank: "", //开户银行名称
            linkId: "", //关联id
            paymentType: "", //付款方式code
            paymentTypeName: "", //付款方式name
            receiveAmount: "", //收款金额
            staffId: "", //收款人id
            staffName: "",
          },
        ],
        baseAnnexes: [],
      },
      selectPeopleNamesArr: [],
      selectPeopleNames: "",
      selectPeopleIds: [],
      claimListItemIndex: 0, //点击所属inedx值
      createTime: "", //申请时间
      projectName: "", //所属项目名称
      typeColumns: [], //资金用途
      refreshPage: false, // 网络请求失败时显示
      clientType: getDeviceType(), //手机类型
      addType: false, //防止高频点击
      showPaymentTypePicker: false, //转账方式弹框
      showFuKuanTypePicker: false, //付款类型弹框
      showRetinuePicker: false, //随行人员弹框
      innerShow: false, //公司内付款明细
      showRelevanceTypePicker: false, //关联类型弹框
      showPaymentTypeList: [
        //转账方式列表
        {
          dictName: "转账",
          dictCode: "zz",
        },
        {
          dictName: "现金",
          dictCode: "xj",
        },
        {
          dictName: "汇票",
          dictCode: "hp",
        },
        {
          dictName: "保函",
          dictCode: "bh",
        },
      ],
      FuKuanTypeList: [
        //付款类型列表
        {
          dictName: "公司内",
          dictCode: "inner",
        },
        {
          dictName: "公司外",
          dictCode: "outer",
        },
      ],
      incomeAndExpenses: {
        income: "",
        expenses: "",
        contractAmount: "", //合同金额
      },
      marketPercent: "", //营销成本比例
      marketingCost: "", // 营销成本
      marketingCostTotal: "", // 累计营销成本
      remainMarketingCost: "", //剩余营销成本
      marketArchive: true, //营销是否封存
      technologyPercent: "", //技术成本比例
      technicalCost: "", // 技术成本
      technicalCostTotal: "", // 累计技术成本
      remainTechnicalCost: "", //剩余技术成本
      technologyArchive: true, //技术成本是否封存
      remainReceptionCost: "", //剩余招待费用
      receptionCostTotal: "", //累计已支出招待费
      receptionCost: "", //招待成本
      receptionPercent: "", //招待成本限额比例
      bidCostTotal: "", //投标成本
      showBxTypePicker: false,

      bxTypeList: [], //报销类型数组
      bxTypeIndex: 1,
      firstContact: [], //营销人员
      pickerType: "", //判断弹出框显示是支出还是收入
      showProjectMoneyPicker: false, //支出或收入详情弹框默认不显示
      moneydetailList: [], //支出或收入详情列表
      refreshing: false, //无数据显示
      verifyPageType: false, //审批弹框,默认不显示
      verifyPageText: "",
      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      sendType: "", //判断是否在抄送列表
      loadingText: "操作中...", //	btn加载状态提示文字
    };
  },
  async mounted() {
    if (is_wei()) {
      document.title = "付款申请";
    }
    this.verifyType = this.$route.query.verifyType; //审核状态是否已审核
    this.fundingType = this.$route.query.fundingType;//1为普通 2为管理付款 获取是否是管理付款
    this.$set(this.propertyData, "applicantIdName", this.userinfo.realName);
    this.commonId = this.$route.query.commonId; //申请Id
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑
    this.sendType = this.$route.query.sendType; // 1：在抄送列表
    this.editType = this.mode == "add" ? true : false;
    window.editPage = this.editPage; //编辑页面

    this.$nextTick(() => {
      this.verifyPageText = this.verifyType == "1" ? "审批" : "查看";
      if (this.mode == "edit" || this.mode == "verify" || this.mode == "view") {
        this.initPage();
      } else {
        this.createTime = dateFormat(new Date());
        this.setShowLoad(false);
      }
    });
    this.typeColumns = await getDictList("zijin"); //字典项接口获取资金用途
  },

  methods: {
    ...mapMutations(["setShowLoad"]),
    addClaim() {
      //添加付款明细函数
      this.propertyData.accountInfoParams.push({
        bankAccount: "", //银行账户
        collectingCompany: "", //收款单位
        depositBank: "", //开户银行名称
        linkId: "", //关联id
        paymentType: "", //付款方式code
        paymentTypeName: "", //付款方式name
        receiveAmount: "", //收款金额
        staffId: "", //收款人id
        staffName: "",
      });
    },
    //监测附件方法
    changebaseAnnexes(data) {
      this.propertyData.baseAnnexes = data;
    },
    delectClaim(index) {
      //删除公司外付款明细
      this.propertyData.accountInfoParams.splice(index, 1);
      this.changeAmount();
    },
    delectInnerClaim(index) {
      //删除公司内付款明细
      this.propertyData.accountInfoParams.splice(index, 1);
      this.selectPeopleIds.splice(index, 1);
      this.selectPeopleNamesArr.splice(index, 1);
      this.selectPeopleNames = this.selectPeopleNamesArr.join(",");
      this.changeAmount();
      if (this.propertyData.accountInfoParams[0]) {
        this.innerShow = true;
      } else {
        this.innerShow = false;
      }
    },
    changeAmount() {
      //改变申请金额
      let totalAmount = 0;
      this.propertyData.accountInfoParams.forEach((item) => {
        totalAmount =
          totalAmount + Number(item.receiveAmount ? item.receiveAmount : 0);
      });

      this.propertyData.amount = totalAmount.toFixed(2);
    },
    // 撤回和删除
    delApply() {
      let _this = this;
      let text = this.propertyData.verifyStatus == "hold" ? "删除" : "撤回";
      this.$dialog
        .alert({
          title: text,
          message: "你确定" + text + "吗?",
        })
        .then(() => {
          _this.btnLoading = true;
          _this.$api.finance.funding
            .deleteRecall(this.propertyData.verifyStatus, _this.propertyData.id)
            .then((res) => {
              if (res.code == "1") {
                let msg = text + "成功";
                closePage(msg);
              } else {
                _this.$toast(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch((err) => {
              console.log(err);
              _this.btnLoading = false;
              _this.$toast("网络失败，请稍后重试");
            });
        });
    },
    editPage() {
      //需要编辑
      this.editType = true;
    },
    verifyPage() {
      //审批弹窗
      this.verifyPageType = true;
    },
    showPaymentType(num) {
      //判断当前是否编辑状态
      if (this.editType) {
        this.claimListItemIndex = num;
        this.showPaymentTypePicker = true;
      }
    },
    //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
    savePaymentLevel(data) {
      this.showPaymentTypePicker = false;
      this.propertyData.accountInfoParams[
        this.claimListItemIndex
      ].paymentTypeName = data.dictName;
      this.propertyData.accountInfoParams[this.claimListItemIndex].paymentType =
        data.dictCode;
    },

    initPage() {
      this.setShowLoad(false);
      let _this = this;
      _this.$api.finance.funding
        .detail(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.selectPeopleIds = [];
            _this.selectPeopleNamesArr = [];
            _this.propertyData = newApi.assign(
              {},
              _this.propertyData,
              res.data
            );
            _this.firstContact = res.data.firstContact;
            _this.createTime = _this.propertyData.createTime.substr(0, 10);
            _this.projectName = res.data.projectName;
            _this.propertyData.paymentTypeName =
              res.data.paymentType == "zz"
                ? "转账"
                : res.data.paymentType == "xj"
                ? "现金"
                :  res.data.paymentType == "hp"
                ? "汇票":"保函";
            _this.propertyData.companyTypeName =
              res.data.companyType == "inner" ? "公司内" : "公司外";
            _this.fundingType = res.data.fundingType;
            _this.$set(_this.propertyData, "projectCode", res.data.projectId);
            _this.propertyData.accountInfoParams = res.data.accountInfoResults;
            this.getIncomeAndExpenses(_this.propertyData.projectId); //获取项目的收支情况
            _this.getCostInfo(res.data.projectId);
            if (res.data.accountInfoResults[0]) {
              res.data.accountInfoResults.forEach((item) => {
                _this.selectPeopleIds.push(item.staffId);

                _this.selectPeopleNamesArr.push(item.staffName);
              });
              _this.selectPeopleNames = _this.selectPeopleNamesArr.join(",");
              _this.innerShow = true;
            }

            if (
              (_this.propertyData.verifyStatus == "hold" ||
                _this.propertyData.verifyStatus == "deny") &&
              _this.mode == "edit"
            ) {
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          _this.$toast("网络失败，请稍后重试");
        });
    },

    setProject(data) {
      //获取所属项目
      let _this = this;
      if (data != "") {
        _this.propertyData.projectId = data.id;

        _this.projectName = data.name;
        _this.firstContact = data.firstContact;
        _this.marketArchive = data.marketArchive;
        _this.technologyArchive = data.technologyArchive;
        if (this.fundingType == "1") {
          this.$set(this.propertyData, "firstTypeName", "");
          this.$set(this.propertyData, "firstType", "");
          this.$set(this.propertyData, "secondTypeName", "");
          this.$set(this.propertyData, "secondType", "");
          this.$set(this.propertyData, "thirdTypeName", "");
          this.$set(this.propertyData, "thirdType", "");
        }

        this.getIncomeAndExpenses(data.id); //获取项目的收支情况
        this.getCostInfo(data.id);
      }
      this.showItemPicker = false;
    },
    //获取报销类型列表
    getBxType(index, parentCode) {
      let _this = this;
      _this.$api.baseCommon.baseMsg.dictBox
        .enableItemList(parentCode)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            let baseData = [];
            let baseList = res.data ? res.data : "";
            // if (parentCode == "bx" || this.fundingType != "1") {
            //   _this.bxTypeList = baseList;
            // } else {
            if (this.fundingType == "1") {
              //一般付款

              if (index == "1") {
                //第一级
                baseList.forEach((item) => {
                  if (item.dictName == "营销成本" && !_this.marketArchive) {
                    if (this.firstContact && this.firstContact[0]) {
                      this.firstContact.forEach((userItem) => {
                        if (userItem == this.userinfo.id) {
                          baseData.push(item);
                        }
                      });
                    }
                  } else if (item.dictName == "项目技术成本") {
                    (this.isZL ||this.userinfo.deptType == "jsbg" || this.userinfo.deptType == "tbbg") && !_this.technologyArchive
                      ? baseData.push(item)
                      : "";
                  } else if (item.dictName == "投标成本") {
                    this.userinfo.deptType == "tbbg" ? baseData.push(item) : "";
                  } else if (
                    item.dictName == "管理成本" &&
                    this.userinfo.deptType != "jsbg" &&
                    this.userinfo.deptType != "yxbg"&& !this.isZL
                  ) {
                    baseData.push(item);
                  } else if (
                    item.dictName != "项目技术成本" &&
                    item.dictName != "营销成本" &&
                    item.dictName != "投标成本" &&
                    item.dictName != "管理成本"
                  ) {
                    baseData.push(item);
                  }
                });
                _this.bxTypeList = baseData;
              } else {
                _this.bxTypeList = baseList;
              }
            } else {
              //管理付款
              _this.bxTypeList = baseList;
            }
          }
          // }
        });
    },
    showBxTypePickerFun(index) {
      //打开类型选择弹窗
      if (!this.editType) {
        return false;
      }
      if (!this.propertyData.projectId) {
        this.$toast("请先选择项目");
        return false;
      }
      if (index == "1") {
        this.getBxType(1, "fk");
      } else if (index == "2") {
        if (!this.propertyData.firstType) {
          this.$toast("请选择上一级");
          return false;
        } else {
          this.getBxType(2, this.propertyData.firstType);
        }
      } else {
        if (!this.propertyData.secondType) {
          this.$toast("请选择上一级");
          return false;
        } else {
          this.getBxType(3, this.propertyData.secondType);
        }
      }
      this.showBxTypePicker = true;
      this.bxTypeIndex = index; //被选择报销列表数组index
    },
    //保存报销类型
    saveBxType(data) {
      let _this = this;
      console.log(_this.bxTypeIndex, "_this.bxTypeIndex");
      if (_this.bxTypeIndex == "1") {
        this.$set(this.propertyData, "firstTypeName", data.dictName);
        this.$set(this.propertyData, "firstType", data.dictCode);
        this.$set(this.propertyData, "secondTypeName", "");
        this.$set(this.propertyData, "secondType", "");
        this.$set(this.propertyData, "thirdTypeName", "");
        this.$set(this.propertyData, "thirdType", "");
      } else if (_this.bxTypeIndex == "2") {
        this.$set(this.propertyData, "secondTypeName", data.dictName);
        this.$set(this.propertyData, "secondType", data.dictCode);
        this.$set(this.propertyData, "thirdTypeName", "");
        this.$set(this.propertyData, "thirdType", "");
      } else {
        this.$set(this.propertyData, "thirdTypeName", data.dictName);
        this.$set(this.propertyData, "thirdType", data.dictCode);
      }
      this.showBxTypePicker = false;
    },
    getIncomeAndExpenses(id) {
      let _this = this;
      _this.$api.finance.reimburse
        .incomeAndExpenses({
          projectId: id,
          dateUnitType: "all",
        })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            console.log(res.data);
            _this.incomeAndExpenses = res.data;

            if (
              res.data.contractAmount != null &&
              parseFloat(res.data.contractAmount) > 0 &&
              res.data.income != null &&
              parseFloat(res.data.income) > 0
            ) {
              let percent = (
                (parseFloat(res.data.income) /
                  parseFloat(res.data.contractAmount)) *
                100
              ).toFixed(2);
              this.$set(
                _this.incomeAndExpenses,
                "income",
                res.data.income + " (" + percent + "%" + ")"
              );
            }
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    //项目id获取成本信息I
    getCostInfo(id) {
      let _this = this;
      _this.$api.finance.reimburse
        .getCostInfo({
          projectId: id,
        })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            console.log(res.data, "CostInfo");

            _this.marketPercent = res.data.marketPercent
              ? Number(res.data.marketPercent).toFixed(2)
              : ""; // 营销成本比例
            _this.marketingCost = res.data.marketingCost
              ? Number(res.data.marketingCost).toFixed(2)
              : ""; // 营销成本
            _this.marketingCostTotal = res.data.marketingCostTotal
              ? Number(res.data.marketingCostTotal).toFixed(2)
              : ""; // 累计营销成本
            _this.remainMarketingCost = res.data.remainMarketingCost
              ? Number(res.data.remainMarketingCost).toFixed(2)
              : ""; //剩余营销成本

            _this.technologyPercent = res.data.technologyPercent
              ? Number(res.data.technologyPercent).toFixed(2)
              : ""; //技术成本比例
            _this.technicalCost = res.data.technicalCost
              ? Number(res.data.technicalCost).toFixed(2)
              : ""; // 技术成本
            _this.technicalCostTotal = res.data.technicalCostTotal
              ? Number(res.data.technicalCostTotal).toFixed(2)
              : ""; // 累计技术成本
            _this.remainTechnicalCost = res.data.remainTechnicalCost
              ? Number(res.data.remainTechnicalCost).toFixed(2)
              : ""; // 剩余技术成本

            _this.receptionPercent = res.data.receptionPercent
              ? Number(res.data.receptionPercent).toFixed(2)
              : ""; //招待成本比例
            _this.receptionCost = res.data.receptionCost
              ? Number(res.data.receptionCost).toFixed(2)
              : ""; // 招待成本
            _this.receptionCostTotal = res.data.receptionCostTotal
              ? Number(res.data.receptionCostTotal).toFixed(2)
              : ""; // 累计已招待成本
            _this.remainReceptionCost = res.data.remainReceptionCost
              ? Number(res.data.remainReceptionCost).toFixed(2)
              : ""; // 剩余招待成本

            _this.bidCostTotal = res.data.bidCostTotal
              ? Number(res.data.bidCostTotal).toFixed(2)
              : ""; // 累计投标成本
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    getMoneyDetail(name) {
      //跳转项目支出,收入详情
      let _this = this;

      _this.pickerType = name;
      _this.getProjectMoneyDetail();
      _this.showProjectMoneyPicker = true;
    },
    getProjectMoneyDetail() {
      //项目支出或收入详情
      let _this = this;
      _this.$api.project
        .projectMoneyDetail(_this.pickerType, 1, 200, {
          dateUnitType: "all",
          projectId: _this.propertyData.projectId,
        })
        .then((res) => {
          if (res.code == "1") {
            _this.moneydetailList = res.data.list;
          } else {
            _this.$toast(res.msg);
          }
          _this.refreshing = true;
        })
        .catch((err) => {
          _this.refreshing = true;
          _this.$toast("网络失败，请稍后重试");
        });
    },
    showItemPickerFun() {
      if (this.editType) {
        this.showItemPicker = true;
      }
    },
    showTypePickerFun() {
      if (this.editType) {
        this.showTypePicker = true;
      }
    },
    saveType(data) {
      this.showTypePicker = false;
      this.$set(this.propertyData, "typeName", data.dictName);
      this.$set(this.propertyData, "type", data.dictCode);
    },
    showFuKuanType() {
      //付款类型
      if (this.editType) {
        this.showFuKuanTypePicker = true;
      }
    },
    saveFuKuanType(data) {
      //保存付款Type
      this.showFuKuanTypePicker = false;
      this.$set(this.propertyData, "companyType", data.dictCode);
      this.$set(this.propertyData, "companyTypeName", data.dictName);
      console.log(data);
    },
    /*选择人员,弹出随行人员组件*/

    showSelectPeople() {
      if (this.editType) {
        this.showRetinuePicker = true;
      }
    },
    /*获取人员信息*/
    setRetinue(newArr, delArr) {
      let _this = this,
        NewNameArr = [],
        datas = [];
      _this.propertyData.accountInfoParams.forEach((item, index) => {
        if (item.staffId == "") {
          _this.propertyData.accountInfoParams.splice(index, 1);
        }
        if (delArr) {
          delArr.forEach((delId) => {
            if (item.staffId == delId) {
              _this.propertyData.accountInfoParams.splice(index, 1);
            }
          });
        }
      });
      if (newArr.length > 0) {
        newArr.forEach((item) => {
          datas.push(item.id);
          NewNameArr.push(item.realName);
        });
        _this.selectPeopleIds = datas;
        _this.selectPeopleNames = NewNameArr.join(",");
        _this.selectPeopleNamesArr = NewNameArr;
        for (let item of newArr) {
          let _index = _this.propertyData.accountInfoParams.findIndex(
            (infoItem) => {
              infoItem.staffId == item.id;
            }
          );
          _index < 0
            ? _this.propertyData.accountInfoParams.push({
                staffId: item.id,
                staffName: item.realName,
              })
            : "";
        }
        _this.unique(_this.propertyData.accountInfoParams); //去重
        _this.innerShow = true;
      }
      _this.changeAmount();
      _this.showRetinuePicker = false;
    },
    unique(arr) {
      for (var i = 0; i < arr.length; i++) {
        for (var j = i + 1; j < arr.length; j++) {
          if (arr[i].staffId == arr[j].staffId) {
            arr.splice(j, 1);
            j--;
          }
        }
      }
      return arr;
    },
    //保存
    checkInput() {
      let _this = this;
      if (this.validate()) {
        console.log(this.propertyData);
        _this.btnLoading = true;
        let params = this.propertyData;
        _this.$api.finance.funding
          .update(this.mode, params)
          .then((res) => {
            if (res.code == "1") {
              let text = this.mode == "add" ? "添加成功" : "编辑成功";
              closePage(text);
              // console.log(text);
            } else {
              _this.$toast(res.msg);
            }
            _this.btnLoading = false;
          })
          .catch((err) => {
            console.log(err);
            _this.btnLoading = false;
            _this.$toast("网络失败，请稍后重试");
          });
      }
    },
    validate() {
      let _this = this;
      let inspectType = true;
      if (
        _this.propertyData.amount == "" ||
        _this.propertyData.projectName == "" ||
        _this.propertyData.firstType == "" ||
        _this.propertyData.secondType == "" ||
        _this.propertyData.thirdType == "" ||
        _this.propertyData.reason == "" ||
        _this.propertyData.companyType == "" ||
        _this.propertyData.accountInfoParams.length < 1
      ) {
        _this.$toast("请完善表单信息");
        inspectType = false;
      }
      if (_this.propertyData.accountInfoParams.length > 0) {
        _this.propertyData.accountInfoParams.forEach((item) => {
          if (_this.propertyData.companyType == "inner") {
            if (
              item.receiveAmount == "" ||
              item.receiveAmount == "0" ||
              item.staffId == "" ||
              !item.receiveAmount
            ) {
              _this.$toast("请完善表单信息");
              inspectType = false;
            }
          }
          if (_this.propertyData.companyType == "outer") {
            if (
              item.collectingCompany == "" ||
              item.paymentType == "" ||
              item.receiveAmount == "" ||
              item.type == ""
            ) {
              console.log(_this.propertyData.accountInfoParams);
              _this.$toast("请完善表单信息");
              inspectType = false;
            } else {
              if (item.paymentType == "zz" || item.paymentType == "hp") {
                if (
                  item.bankAccount == "" ||
                  item.receiveAmount == "0" ||
                  item.depositBank == ""
                ) {
                  _this.$toast("请完善表单信息");
                  inspectType = false;
                }
              }
            }
          }
        });
      }

      return inspectType;
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
    isZL(){//是否是助理角色
      let index = this.userinfo.roleIds.findIndex(item=>item == '111' || item == '112')
      return index>=0
    },
  },
  watch: {},
};
</script>
<style lang="less">
.reimbursementPage {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .roleBox {
    width: 100%;
    height: 100%;
    padding-top: 15px;
  }
  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.moreText {
    .van-cell {
      .van-cell__title {
        width: 200px;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .dwBox {
    .van-cell {
      .van-cell__title {
        width: 140px;
      }
    }
  }
  //添加明细样式
  .claimDetailMain {
    background-color: #fff;
    .fgx {
      width: 100%;
      height: 10px;
      background-color: #f6f6f6;
    }
    p.tit {
      position: relative;
      padding: 0 16px 0 16px;
      font-size: 15px;
      height: 45px;
      line-height: 45px;
      position: relative;
      color: #2581d6;
      font-weight: 700;
      border-bottom: 1px solid #f6f6f6;
    }
    // p.tit:before {
    //   content: "";
    //   position: absolute;
    //   width: 5px;
    //   height: 20px;
    //   background: #2581d6;
    //   top: 13px;
    //   left: 16px;
    // }
    .baseNone::after {
      content: none;
    }
    .claimDetailBox.van-cell-group.van-hairline--top-bottom::after {
      content: none;
    }
  }
  .claimDetailBox {
    width: 100%;
    padding-bottom: 10px;
    .claimDetailLists {
      width: 95%;
      margin: 0 auto;
      min-height: 105px;
    }
    .addBtn {
      margin-top: 10px;
      width: 100%;
      .addClaim {
        display: block;
        margin: 0 auto;
        border-radius: 8px;
        -webkit-border-radius: 8px;
        -moz-border-radius: 8px;
      }
    }
  }
  .claimItem {
    margin-top: 10px;
    border: 1px solid #f1f1f1;
    border-radius: 4px;
    position: relative;
    .delectClaim {
      text-align: center;
      position: absolute;
      top: -6px;
      right: -4px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      border-radius: 50%;
      background: #fff;
      border: 1px solid red;
      color: red;
      cursor: pointer;
      padding-top: 1px;
      z-index: 55;
    }
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }

  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin-top: 10px;
  }
  .moneyPicker {
    width: 100%;
    height: 90%;

    background-color: #fff;
    .van-popup__close-icon--top-right {
      top: 5px;
      right: 5px;
      color: red;
    }
    ul {
      width: 100%;
      height: 100%;
      overflow-y: scroll;

      padding: 16px 16px 20px 16px;

      li {
        width: 100%;
        padding: 8px 8px;
        margin: 10px 0;
        background-color: #fff;
        border: 1px solid #eeeeee;
        border-radius: 8px;
        -webkit-border-radius: 8px;
        -moz-border-radius: 8px;
        .incomeInfo {
          p {
            width: 100%;
            overflow: hidden;
            font-size: 15px;
            line-height: 20px;
            margin: 5px 0;
            color: #333;
          }
        }
      }
    }
    .nonePage {
      width: 120px;
      height: 135px;

      position: absolute;
      left: 50%;
      margin-left: -60px;
      top: 50%;
      margin-top: -67px;
      img {
        display: block;
        max-width: 100px;
        max-height: 100px;
        margin: 0 auto;
      }

      p {
        margin-top: 10px;
        text-align: center;
        color: #5c5d5d;
        font-size: 16px;
      }
    }
  }
}
</style>